import { render, staticRenderFns } from "./VaffPasswordField.vue?vue&type=template&id=7c89023e&"
import script from "./VaffPasswordField.vue?vue&type=script&lang=js&"
export * from "./VaffPasswordField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports